import React, { useContext } from "react";
import { Spinner } from "components/common";
import { Label } from "components/bootstrap";
import ForwardersContext from "../forwarders/ForwardersContext";
const stateToLabelStyle = (state) => {
  switch (state) {
    case "RUNNING":
    case "CONNECTED":
      return "success";
    case "FAILED":
    case "DISCONNECTED":
      return "danger";
    case "STARTING":
      return "info";
    default:
      return "warning";
  }
};
const stateToLabelText = (state) => {
  switch (state) {
    case "RUNNING":
      return "Running";
    case "FAILED":
      return "Failed";
    case "STARTING":
      return "Starting";
    case "CONNECTED":
      return "Connected";
    case "DISCONNECTED":
      return "Disconnected";
    case "STOPPED":
      return "Not running";
    default:
      return "Unknown";
  }
};
const ForwarderStateBadge = ({ forwarderId }) => {
  const { getForwarderContext } = useContext(ForwardersContext);
  const { state: forwarderState } = getForwarderContext(forwarderId);
  if (!forwarderState) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: stateToLabelStyle(forwarderState) }, stateToLabelText(forwarderState));
};
export default ForwarderStateBadge;
